import { createFileRoute } from '@tanstack/react-router'
import { MyTemplateRequestsList } from '@/views/template-requests/list'
import { Main } from '@/components/layout/main'

export const Route = createFileRoute('/_authenticated/template-requests')({
    component: Page,
})

function Page() {
    return (
        <Main>
            <MyTemplateRequestsList />
        </Main>
    )
}
